import { isGroupNavItem } from "./index";
import { type SingleLineItem, type SingleLineMenu } from "../types";

export function getPageNavBarItems(items: SingleLineMenu) {
  return items.filter((item) => !isGroupNavItem(item)) as SingleLineItem[];
}
